<template>
    <tool></tool>
</template>

<script>
import Tool from 'components/page/Tool'


export default {
  components: {
    Tool
  }
}
</script>



// WEBPACK FOOTER //
// Tool.vue?7aabc470